/**
 * @file table.actions.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Nov 06, 2025 20:51
 */

// -------------------------------------------------------------------
// dialog setters
// -------------------------------------------------------------------
export const TABLE_EDIT_DIALOG_SET = 'TABLE_EDIT_DIALOG_SET';
export function tableEditDialogSet(value) {
    return {
        type: TABLE_EDIT_DIALOG_SET,
        payload: value,
    };
}

export const TABLE_VIEW_DIALOG_SET = 'TABLE_VIEW_DIALOG_SET';
export function tableViewDialogSet(value) {
    return {
        type: TABLE_VIEW_DIALOG_SET,
        payload: value,
    };
}

export const TABLE_VIEW_RESET = 'TABLE_VIEW_RESET';
export function tableViewReset() {
    return {
        type: TABLE_VIEW_RESET,
    };
}

// -------------------------------------------------------------------
// table.edit
// -------------------------------------------------------------------
export const TABLE_EDIT_REQUEST = 'TABLE_EDIT_REQUEST';
export function tableEditRequest(tableId) {
    return {
        type: TABLE_EDIT_REQUEST,
        payload: {
            tableId,
        }
    };
}

export const TABLE_EDIT_SUCCESS = 'TABLE_EDIT_SUCCESS';
export function tableEditSuccess(payload) {
    return {
        type: TABLE_EDIT_SUCCESS,
        payload,
    };
}

export const TABLE_EDIT_FAILURE = 'TABLE_EDIT_FAILURE';
export function tableEditFailure(error) {
    return {
        type: TABLE_EDIT_FAILURE,
        payload: JSON.stringify(error),
    };
}

// -------------------------------------------------------------------
// table.update
// -------------------------------------------------------------------
export const TABLE_UPDATE_REQUEST = 'TABLE_UPDATE_REQUEST';
export function tableUpdateRequest(tableId, changeSet) {
    return {
        type: TABLE_UPDATE_REQUEST,
        payload: {
            tableId,
            changeSet,
        }
    };
}

export const TABLE_UPDATE_SUCCESS = 'TABLE_UPDATE_SUCCESS';
export function tableUpdateSuccess(payload) {
    return {
        type: TABLE_UPDATE_SUCCESS,
        payload,
    };
}

export const TABLE_UPDATE_FAILURE = 'TABLE_UPDATE_FAILURE';
export function tableUpdateFailure(error) {
    return {
        type: TABLE_UPDATE_FAILURE,
        payload: JSON.stringify(error),
    };
}

// -------------------------------------------------------------------
// table.view
// -------------------------------------------------------------------
export const TABLE_VIEW_REQUEST = 'TABLE_VIEW_REQUEST';
export function tableViewRequest(tableId) {
    return {
        type: TABLE_VIEW_REQUEST,
        payload: {
            tableId,
        }
    };
}

export const TABLE_VIEW_SUCCESS = 'TABLE_VIEW_SUCCESS';
export function tableViewSuccess(payload) {
    return {
        type: TABLE_VIEW_SUCCESS,
        payload,
    };
}

export const TABLE_VIEW_FAILURE = 'TABLE_VIEW_FAILURE';
export function tableViewFailure(error) {
    return {
        type: TABLE_VIEW_FAILURE,
        payload: JSON.stringify(error),
    };
}